import {put, take} from "redux-saga/effects";
import {closeDialog, showDialog} from "../actions";
import {INotificationDialogOptions} from "../types";
import i18n from "../../../shared/i18n";

export function* showConfirmationDialog(text: string, yesButton?: string, noButton?: string) {
    yield put(showDialog({
        type: 'NotificationDialog',
        options: {
            title: text,
            actions: [
                {
                    label: yesButton || i18n("dialog.yesbutton"),
                    payload: { value: true }
                },
                {
                    label: noButton || i18n("dialog.nobutton"),
                    payload: { value: false }
                }
            ]
        } as INotificationDialogOptions
    }));

    const {payload} = yield take(closeDialog);

    return payload && payload.value;
}